import { useMutationFill } from '../../api';
import { LoaderScreen } from '@workspace/core-ts/components';
import { SmartFormGlobal, useGlobalForm, useSmartFormGlobal } from '../../contexts';
import { useContent, useSource } from '../../hooks';
import type { StepContentConfig } from '../../utils';
import { validationStepContent } from '../../content';
import { useEffect, useRef, useState } from 'react';

const REFRESH_INTERVAL = 5;

interface ValidationStepProps {
  content?: StepContentConfig;
  signatureStepSlug?: string;
  documentsStepSlug?: string;
}

export function ValidationStep({
  content = validationStepContent,
  signatureStepSlug = 'signature',
  documentsStepSlug = 'pieces-justificatives'
}: ValidationStepProps) {
  const methods = useSmartFormGlobal<any>();
  const { others, setDisableNavigation, actions, meta } = useGlobalForm();
  const mutationFill = useMutationFill(meta.token);
  const r = useContent();
  const intervalRef = useRef<number | null>(null);
  const hasNavigatedRef = useRef(false);
  const [dataLoaded, setDataLoaded] = useState(false);

  const state = others.state;
  const signatures = others.signatures;
  const source = useSource()

  const resetIntervals = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      handleFill();
    }, REFRESH_INTERVAL * 1000);
  };

  useEffect(() => {
    setDisableNavigation(true);
    handleFill();
    resetIntervals();

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (hasNavigatedRef.current) return;

    if (state === 'contrat') {
      let step = null;
      if (source.isDirect || source.isConseiller) {
        if (signatures.length > 0 && !signatures[0].refused) {
          step = signatureStepSlug;
        } else if (dataLoaded && signatures.length === 0) {
          step = documentsStepSlug;
        }
      } else if (source.isCourtier || source.isConseiller) {
        step = documentsStepSlug;
      }

      if (step) {
        hasNavigatedRef.current = true;
        actions.goToStep(step);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, signatures, source, dataLoaded, signatureStepSlug, documentsStepSlug]);

  const handleFill = () => {
    mutationFill.mutateAsync(methods.getValues()).then((response) => {
      actions.saveData(response);
      setDataLoaded(true);

      if (!response.payments[response.payments?.length - 1]?.paid || response.state !== 'contrat') {
        resetIntervals();
      }
    });
  };

  return (
    <SmartFormGlobal
      {...methods}
      className="mx-auto"
    >
      <LoaderScreen text={r(content.loadingText)} />
    </SmartFormGlobal>
  );
}
